import { ObjectType } from '../../types/objectType';
import { v4 as uuidv4 } from 'uuid';


// Constants
const initialData = {
  isLoading: false,
  isError: false,
  externalParams: {
    sessionId: uuidv4(),
    legacy: true,
    step: 3,
    provider: 'iberia',
    category: 'none',
    enabledCategory: true,
    defaultCups: '',
  }
};

// Redux Types
const TOGGLE_IS_ERROR = 'TOGGLE_IS_ERROR';
const TOGGLE_CONTRACT_TYPE = 'TOGGLE_CONTRACT_TYPE';
const SET_SESSION_ID = 'SET_SESSION_ID';
const SET_DEFAULT_CUPS = 'SET_DEFAULT_CUPS';
const CHANGE_PARAMS = 'CHANGE_PARAMS';


// Redux Reducer
export default function reducer(state = initialData, action: ObjectType) {
  switch (action.type) {
    case TOGGLE_IS_ERROR:
      return { ...state, ...action.payload };
    case TOGGLE_CONTRACT_TYPE:
      return { ...state, ...action.payload };
    case SET_SESSION_ID:
    case SET_DEFAULT_CUPS:
    case CHANGE_PARAMS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

// Redux Actions


export const toggleIsError = (error: any = false) => async (dispatch: any, getState: any) => {
  const initialList = getState();
  return dispatch({
    type: TOGGLE_IS_ERROR,
    payload: { isError: !initialList.isError, error },
  });
};

export const toggleContractType = (params: any = { category: '' }) => async (dispatch: any, getState: any) => {
  const initialList = getState().appReducer;
  return dispatch({
    type: TOGGLE_CONTRACT_TYPE,
    payload: { externalParams: initialList.externalParams, contractType: params },
  });
};

export const setSessionId = (uuid: string) => async (dispatch: any, getState: any) => {
  const initialList = getState().appReducer;
  return dispatch({
    type: SET_SESSION_ID,
    payload: { externalParams: { ...initialList.externalParams, sessionId: uuid } },
  });
}

export const setDefaultCups = (cups: string) => async (dispatch: any, getState: any) => {
  const initialList = getState().appReducer;
  return dispatch({
    type: SET_DEFAULT_CUPS,
    payload: { externalParams: { ...initialList.externalParams, defaultCups: cups } },
  });
}

export const changeParams = (params: any = { category: '' }) => async (dispatch: any, getState: any) => {
  const initialList = getState().appReducer;
  return dispatch({
    type: CHANGE_PARAMS,
    payload: { externalParams: { ...initialList.externalParams, ...params } },
  });
};


